<template lang="pug">
  .component-create-packet-entity-button
    ModalReveal(ref="editPacketModal", :key="_uid")
      button.button(slot="trigger" ) Edit
      h2 Edit packet
      PacketForm(v-model="body")
      ActionButton(:action="edit", slot="footer") Save

</template>

<script>
import ModalReveal from "../../../foundation/ModalReveal";
import ActionButton from "../../ActionButton";
import KeplerBackofficeSdk from "../../../../../lib/kepler/backoffice";
import MaggieHelper from "../../../../../maggieHelper";
import Editor from "../../Editor.vue";
import PacketForm from "../../../forms/PacketForm.vue";
import {EventBus} from "src/eventBus";

export default {
  name: "EditPacketReveal",
  components: {
    PacketForm,
    Editor,
    ModalReveal,
    ActionButton
  },
  data() {
    return {
      body: {...this.item}
    }

  },
  created() {
  },

  methods: {
    edit() {
      return KeplerBackofficeSdk.packets.select(this.body).edit(this.body, (data) => {
        MaggieHelper.notification('Updated packet ', 'id:' + data.id)
        EventBus.$emit('reload-list')
        this.$refs.editPacketModal.close()
      })
    }
  },
  props: ['item']
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// EditPacketReveal.vue?6acd63aa